import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

/* global google */
function PlaceGoogleMap( args ) {
	if( 'undefined' != typeof google && 'undefined' != typeof google.maps ) {
		let that = this;
		args = args || {};

		// Defaults (utiliser ?? pour conserver les false)
		args.center = args.center ?? null;
		args.zoom = args.zoom ?? 16;
		args.markerSel = args.markerSel ?? '.marker';
		args.styles = args.styles ?? [];
		args.navigationControl = args.navigationControl ?? true;
		args.mapTypeControl = args.mapTypeControl ?? false;
		args.zoomControl = args.zoomControl ?? true;
		args.streetViewControl = args.streetViewControl ?? false;
		args.scaleControl = args.scaleControl ?? false;
		args.fullscreenControl = args.fullscreenControl ?? false;
		args.gestureHandling = args.gestureHandling ?? 'auto';
		args.mapTypeId = args.mapTypeId ?? google.maps.MapTypeId.ROADMAP;

		args.markerIconUrl = args.markerIconUrl ?? window.nubeeGlobals.themeDir + '/assets/images/map-marker.svg';
		args.clusterIconUrl = args.clusterIconUrl ?? window.nubeeGlobals.themeDir + '/assets/images/map-cluster.svg';
		args.markerIconWidth = args.markerIconWidth ?? 56;
		args.markerIconHeight = args.markerIconHeight ?? 58;
		args.onlyOneInfoWindow = args.onlyOneInfoWindow ?? true;

		this.args = args;

		this.init = function() {
			that.map = null;
			that.mapParent = that.args.mapParent;
			that.markerEls = that.mapParent.querySelectorAll( args.markerSel );
			that.markers = [];
			that.openInfoWindows = [];
			that.markersToOpenOnLoad = [];
			that.markerCluster = null; // Store the MarkerClusterer instance

			that.mapLoading = that.mapParent.nextElementSibling;
			that.mapLoadingLoader = that.mapLoading ? that.mapLoading.querySelector( '.loader' ) : null;
			that.mapLoadingStatus = that.mapLoading ? that.mapLoading.querySelector( '.status' ) : null;

			// Pas de centre par défaut ? On choisit le premier marqueur.
			if( ! that.args.center && that.markerEls.length > 0 ) {
				that.args.center = {
					lat: parseFloat( that.markerEls[0].dataset.lat ),
					lng: parseFloat( that.markerEls[0].dataset.lng ),
				};
			}

			if( that.args.center ) {
				that.args.center = new google.maps.LatLng( that.args.center );
			} else {
				that.args.center = new google.maps.LatLng({ lat: 0, lng: 0 });
			}

			that.render();
			that.addMarkers();

			// Initialize cluster after markers exist
			that.addCluster();

			that.center();
			that.openDefaultMarkers();
		};

		this.render = function() {
			let mapArgs = {
				zoom: that.args.zoom,
				center: that.args.center,
				navigationControl: that.args.navigationControl,
				mapTypeControl: that.args.mapTypeControl,
				zoomControl: that.args.zoomControl,
				streetViewControl: that.args.streetViewControl,
				scaleControl: that.args.scaleControl,
				fullscreenControl: that.args.fullscreenControl,
				gestureHandling: that.args.gestureHandling,
				mapTypeId: that.args.mapTypeId,
				styles: that.args.styles,
			};

			that.map = new google.maps.Map( that.mapParent, mapArgs );

			//Quand la map a complètement fini de charger, ajout d'une classe
			google.maps.event.addListenerOnce( that.map, 'idle', function() {
				that.args.mapParent.classList.add( 'map-loaded' );
			});
		};

		this.addCluster = function() {

			// Cleanup existing cluster (important for updateMarkers)
			if( that.markerCluster ) {
				that.markerCluster.setMap( null );
				that.markerCluster = null;
			}

			const colors = [ '#EF8450', '#2A6255', '#10393B' ];

			const ClusterIcon = color => window.btoa(`
				<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
				<circle cx="120" cy="120" opacity=".9" r="70" />
				<circle cx="120" cy="120" opacity=".4" r="95" />
				<circle cx="120" cy="120" opacity=".2" r="120" />
			</svg>`);

			// Modern MarkerClusterer API
			that.markerCluster = new MarkerClusterer({
				map: that.map,
				markers: that.markers,
				renderer: {
					render: ({ count, position }) => {
						const color = colors[ count % colors.length ];
						const url = `data:image/svg+xml;base64,${ClusterIcon( color )}`;

						return new google.maps.Marker({
							position: position,
							icon: {
								url: url,
								scaledSize: new google.maps.Size( 50, 50 ),
							},
							label: {
								text: String( count ),
								color: 'white',
								fontSize: '14px',
								fontWeight: '600',
							},
							zIndex: Number( google.maps.Marker.MAX_ZINDEX ) + count,
						});
					},
				},
			});
		};

		this.addMarkers = function() {
			that.markerEls.forEach( function( thisEl ) {
				that.addMarker( thisEl );
			} );
		};

		this.addMarker = function ( markerEl ) {
			let markerArgs = {};
			let markerIconUrl, markerIconWidth, markerIconHeight, marker;

			markerIconUrl = markerEl.dataset.icon || that.args.markerIconUrl;
			markerIconWidth = parseFloat( markerEl.dataset.iconWidth || that.args.markerIconWidth );
			markerIconHeight = parseFloat( markerEl.dataset.iconHeight || that.args.markerIconHeight );

			markerArgs.position = new google.maps.LatLng(
				parseFloat( markerEl.dataset.lat ),
				parseFloat( markerEl.dataset.lng )
			);

			markerArgs.map = that.map;
			markerArgs.title = markerEl.dataset.label;

			if ( markerIconUrl ) {
				if ( /\.svg(#.*)?$/i.test( markerIconUrl ) ) {
					markerArgs.icon = {
						url: markerIconUrl,
						scaledSize: new google.maps.Size( markerIconWidth, markerIconHeight ),
					};
				} else {
					markerArgs.icon = markerIconUrl;
				}
			}

			markerArgs.styles = that.args.styles || null;

			marker = new google.maps.Marker( markerArgs );

			// Create a CustomInfoWindow instance
			const customInfoWindow = new CustomInfoWindow( markerArgs.position );

			google.maps.event.addListener( marker, 'click', function () {
				// Close all open InfoWindows
				that.openInfoWindows.forEach( ( infoWindow ) => infoWindow.onRemove() );
				that.openInfoWindows = []; // Clear array

				// Show loading content
				customInfoWindow.setContent( '<div class="loading-infowindow"><div class="loader"></div> Chargement...</div>' );
				customInfoWindow.setMap( that.map );

				that.map.panTo( marker.getPosition() );
				that.map.panBy( 0, -100 );

				that.openInfoWindows.push( customInfoWindow ); // Track the new window

				let formData = new FormData();
				formData.append( 'action', 'ilcq_infowindow_content' );
				formData.append( 'place_id', markerEl.dataset.postId );

				// Fetch dynamic content
				fetch( nubeeGlobals.ajaxUrl, {
					method: 'POST',
					credentials: 'same-origin',
					body: formData,
				} ).then( ( response ) => response.json() )
					.then( ( response ) => {
						const content = '<div class="info-marker-inner">' + "\n" +
							( response.data.image ? '<div class="marker-image">' + "\n" +
								response.data.image + "\n" +
							'</div>' + "\n" : '' ) +
							'<div class="marker-content">' + "\n" +
								'<h3 class="title title-4">' +
									response.data.post_title +
								'</h3>' + "\n" +
								( response.data.address ? '<p class="address">' +
									response.data.address +
								'</p>' + "\n" : '' ) +
								'<p class="buttons"><a href="' + response.data.link.url + '" class="button half-naked arrow-after">' +
									response.data.link.title +
								'</a></p>' + "\n" +
							'</div>' + "\n" +
						'</div>';

						customInfoWindow.setContent( content );

						setTimeout( function(){
							that.map.panTo( marker.getPosition() );
							that.map.panBy( 0, -100 );
						}, 100);
					})
					.catch( ( error ) => {
						customInfoWindow.setContent( String( error ) );
					});
			});

			that.markers.push( marker );

			// Si un cluster existe déjà, on ajoute le marker (utile si markers ajoutés en cours de route)
			if( that.markerCluster ) {
				that.markerCluster.addMarker( marker, true );
			}

			return marker;
		};

		this.center = function() {
			let bounds = new google.maps.LatLngBounds();

			that.markers.forEach( function( thisMarker ) {
				let latLng = new google.maps.LatLng( thisMarker.position.lat(), thisMarker.position.lng() );
				bounds.extend( latLng );
			} );

			if( 1 == that.markers.length ) {
				that.map.setCenter( bounds.getCenter() );
				that.map.setZoom( that.args.zoom );
			} else if( that.markers.length > 1 ) {
				that.map.fitBounds( bounds );
			}
		};

		this.openDefaultMarkers = function() {
			google.maps.event.addListenerOnce( that.map, 'idle', function() {
				that.markersToOpenOnLoad.forEach( function( thisMarker ) {
					if( thisMarker.infoWindow ) {
						thisMarker.infoWindow.open( that.map, thisMarker );
					}
				} );
			} );
		};

		// Define CustomInfoWindow class
		class CustomInfoWindow extends google.maps.OverlayView {
			constructor( position, content ) {
				super();
				this.position = position;
				this.content = content || '<div class="loading-infowindow"><div class="loader"></div> Chargement...</div>';
				this.div = null;
				this.closeCallback = null; // Optional callback to notify when closed
			}

			onAdd() {
				// Create the div only if it doesn't exist
				if( ! this.div ) {
					this.div = document.createElement( 'div' );
					this.div.className = 'custom-info-window';
					this.div.innerHTML = `
						<div class="custom-info-window-inner">
							<button class="custom-info-window-close">&times;</button>
							${this.content}
						</div>
					`;

					this.getPanes().floatPane.appendChild( this.div );

					// Close button functionality
					const closeBtn = this.div.querySelector( '.custom-info-window-close' );
					if( closeBtn ) {
						closeBtn.addEventListener( 'click', () => {
							this.onRemove();
							if( this.closeCallback ) {
								this.closeCallback();
							}
						});
					}
				}
			}

			draw() {
				if( ! this.div ) return; // Ensure div is available before proceeding

				const projection = this.getProjection();
				const position = projection.fromLatLngToDivPixel( this.position );

				// Update position and center
				this.div.style.left = `${position.x - this.div.offsetWidth / 2}px`; // Center horizontally
				this.div.style.top = `${position.y - this.div.offsetHeight}px`; // Position above marker
			}

			onRemove() {
				if( this.div && this.div.parentNode ) {
					this.div.parentNode.removeChild( this.div );
					this.div = null;
				}
			}

			setContent( content ) {
				this.content = content;

				if( this.div ) {
					this.div.querySelector( '.custom-info-window-inner' ).innerHTML = `
						<button class="custom-info-window-close">&times;</button>
						${content}
					`;

					const closeBtn = this.div.querySelector( '.custom-info-window-close' );
					if( closeBtn ) {
						closeBtn.addEventListener( 'click', () => {
							this.onRemove();
						});
					}
				}
			}

			// Method to set a close callback
			setCloseCallback( callback ) {
				this.closeCallback = callback;
			}
		}

		this.updateMarkers = function ( regionId, mrcId, municipalityId ) {
			if( that.mapLoadingLoader ) {
				that.mapLoadingLoader.classList.remove( 'hidden' );
			}
			if( that.mapLoadingStatus ) {
				that.mapLoadingStatus.textContent = nubeeGlobals.i18n.ilcq.map.loadingMarker;
			}
			if( that.mapLoading ) {
				that.mapLoading.classList.remove( 'hidden' );
			}

			// Clear existing cluster and markers
			if( that.markerCluster ) {
				that.markerCluster.setMap( null );
				that.markerCluster = null;
			}

			that.markers.forEach( marker => marker.setMap( null ) );
			that.markers = []; // Reset the markers array

			// Prepare form data for the AJAX request
			const formData = new FormData();
			formData.append( 'action', 'ilcq_filtered_markers' );
			formData.append( 'region_id', regionId || '' );
			formData.append( 'mrc_id', mrcId || '' );
			formData.append( 'municipality_id', municipalityId || '' );

			// Fetch the new marker data
			fetch( nubeeGlobals.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body: formData,
			} )
				.then( response => response.json() )
				.then( data => {
					if( data.success && Array.isArray( data.data ) ) {
						if( data.data.length > 0 ) {
							// Add each new marker to the map
							data.data.forEach( markerData => {
								// Create a new marker element
								const markerEl = document.createElement( 'div' );
								markerEl.dataset.lat = parseFloat( markerData.lat );
								markerEl.dataset.lng = parseFloat( markerData.lng );
								markerEl.dataset.label = markerData.label;
								markerEl.dataset.postId = markerData.post_id;

								that.addMarker( markerEl );
							});

							// Update the cluster with new markers
							that.addCluster();

							// Adjust the map bounds to fit new markers
							that.center();

							if( that.mapLoading ) {
								that.mapLoading.classList.add( 'hidden' );
							}
						} else {
							if( that.mapLoadingLoader ) {
								that.mapLoadingLoader.classList.add( 'hidden' );
							}
							if( that.mapLoadingStatus ) {
								that.mapLoadingStatus.textContent = nubeeGlobals.i18n.ilcq.map.noMarker;
							}
						}
					} else {
						console.error( 'Failed to load markers:', data );
					}
				})
				.catch( error => {
					console.error( 'Error fetching markers:', error );
				});
		};

		this.init();
	} else {
		console.error( "GoogleMap : Google Maps API script must be enqueued for this page. Check functions.php > page_has_map()." );
	}
}

export default PlaceGoogleMap;